import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Atom from '../components/atom';
import Storage from '../lib/storage/storage';
import { Trn } from '../translations/language';
import ErrorComponent from '../components/error';

interface RouterErrorProps {
  message?: string;
}
const DEFAULT_APP = 'home';
const DEFAULT_VIEW = 'home';
const ARC_PATTERN = /^\/ARC(?:-(\w+))?\/(.*)$/;

export const LoadingCenter = () => (
  <Atom.Div className="absoluteCentered">
    <Atom.Div className="text-center">
      <Atom.Spinner color="primary" />
    </Atom.Div>
    <Atom.Typography type="h6" className="text-center">
      {Trn({ text: 'waiting' })}
    </Atom.Typography>
  </Atom.Div>
);

export const RouterErrorComponent = ({ message }: RouterErrorProps) => (
  <Atom.Div className="overflow-x-hidden">
    <Atom.Div className="mt-5">
      <Atom.H1 className="text-center">
        {message || Trn({ text: 'not_found' })}!
      </Atom.H1>
      <Atom.Div className="row pt-5">
        <Atom.H4 className="text-center offset-1 col-10">
          {Trn({ text: 'sorry_but_we_didnt_page_you_want' })}
        </Atom.H4>
      </Atom.Div>
      <Atom.Div className="pt-5">
        <ErrorComponent code="404" />
      </Atom.Div>
      <Atom.Div className="pt-4">
        <Atom.H5 className="text-center">
          {Trn({ text: 'its_because_of_many_reason' })}
        </Atom.H5>
        <Atom.P />
        <Atom.Ul>
          <Atom.Li className="text-center">{Trn({ text: 'page_404' })}</Atom.Li>
          <Atom.Li className="text-center">
            {Trn({ app: '', text: 'page_404_delete_page' })}
          </Atom.Li>
          <Atom.Div className="text-center errorContainer p-3 offset-2">
            <Atom.Form
              action="/ARC/search/all/"
              role="form"
              method="post"
              className="row g-2"
            >
              <Atom.Div className="col-7 mt-2">
                <input
                  type="text"
                  name="q"
                  className="col-auto form-control"
                  placeholder={Trn({ text: 'enter_phrase' })}
                />
              </Atom.Div>
              <Atom.Div className="col-2">
                <Atom.GButton color="success" type="submit">
                  {Trn({ text: 'search' })}
                </Atom.GButton>
              </Atom.Div>
            </Atom.Form>
          </Atom.Div>
          <Atom.Li className="text-center">
            {Trn({ text: 'maybe_you_dont_have_permission' })}&nbsp;
            <Atom.A href="/?app=contact&amp;view=CV&amp;ID=1">
              {Trn({ text: 'contact_us' })}
            </Atom.A>
            {Trn({ text: 'to_find_reason' })}
          </Atom.Li>
        </Atom.Ul>
      </Atom.Div>
    </Atom.Div>
  </Atom.Div>
);

export const parseURL = ({
  path,
  search,
}: {
  path: string;
  search?: string;
}) => {
  // Handle ARC format URLs
  const match = path.match(ARC_PATTERN);

  if (match) {
    const [, lang, rest] = match;
    if (lang) Storage.setLanguage(lang);

    const [app, view, ...vars] = rest.split('/');
    return {
      app: app || DEFAULT_APP,
      view: view || DEFAULT_VIEW,
      vars,
    };
  }

  // Handle query string format
  const searchParams = new URLSearchParams(
    search || path.includes('?') ? path : ''
  );
  return {
    app: searchParams.get('app') || DEFAULT_APP,
    view: searchParams.get('view') || DEFAULT_VIEW,
    vars: [],
  };
};

export const getSearchVars = (str: string) => {
  const params = new URLSearchParams(decodeURI(str).split('?')[1] || '');
  const filters = {};

  for (const [key, value] of params.entries()) {
    if (key.includes(':')) continue;

    const isIgnored = key.startsWith('!');
    const cleanKey = isIgnored ? key.slice(1) : key;

    if (cleanKey.includes('[')) {
      const [baseKey, ...indices] = cleanKey.split('[');
      const finalKey = isIgnored ? `!${baseKey}` : baseKey;

      if (!filters[finalKey]) {
        filters[finalKey] = {};
      }

      let current = filters[finalKey];
      for (let i = 0; i < indices.length - 1; i++) {
        const index = indices[i].replace(']', '');
        if (!current[index]) current[index] = {};
        current = current[index];
      }

      const lastIndex = indices[indices.length - 1].replace(']', '');
      current[lastIndex] = value;
    } else {
      filters[isIgnored ? `!${cleanKey}` : cleanKey] = value;
    }
  }

  return filters;
};

export function getSearchVarsArray(str) {
  // debugger
  const params = decodeURI(str);
  let newParams = params.split('?')[1];
  let filters = [];
  if (params && newParams) {
    const list = newParams.split('&');
    let object = {};
    for (let i in list) {
      let ignore = false;
      let accept = true;
      let [key, value] = list[i].split('=');
      if (key.includes('!')) {
        key = key.replace('!', '');
        ignore = true;
      }
      //اگر : بعد از مساوی باشد نباید داخل لیست بیاید
      if (key.includes(':')) {
        key = key.replace(':', '');
        accept = false;
      }

      if (accept) {
        if (key.includes('[')) {
          const array = key.split('[');
          let originalKey = array[0];
          if (ignore) {
            originalKey = `!${originalKey}`;
          }
          array.shift();
          // let object = { [originalKey]: {} };
          if (!object[originalKey]) {
            object[originalKey] = {};
          }
          const loopArray = [];
          for (let i = 0; i < array.length; i++) {
            if (array[i].includes(']')) {
              const index = array[i].split(']')[0];
              if (i === 0) {
                if (array.length === 1) {
                  object[originalKey][index] = value;
                } else {
                  if (!object[originalKey][index]) {
                    object[originalKey][index] = {};
                  }
                }
                loopArray.push(index);
              } else {
                //todo:اینجا باید برای آرایه یا آبجکت چند بعدی لوپ بخوره
                // let temp = { ...object[originalKey] };
                // for (let j = 0; j < loopArray.length; j++) {
                //   temp = temp[loopArray[j]];
                // }
                // temp[index] = value;
                object[originalKey][loopArray[0]][index] = value;
              }
            }
          }
          filters = [...filters, Object.values(object)[0]];
        } else {
          if (ignore) {
            key = `!${key}`;
          }
          filters.push(value);
        }
      }
    }
  }

  return filters;
}

const loadComponent = (app: string, view: string) => {
  try {
    return lazy(() => import(`./${app}/${view}/index.tsx`));
  } catch (error) {
    return {
      default: () => (
        <RouterErrorComponent message={Trn({ text: 'page_not_found' })} />
      ),
    };
  }
};

const DynamicRouter = () => {
  const location = useLocation();
  const [Component, setComponent] = useState<React.ElementType | null>(null);

  useEffect(() => {
    let { app, view } = parseURL({
      path: location.pathname,
      search: location.search,
    });

    if (!app && !view && (location.pathname === '/' || !location.pathname)) {
      app = DEFAULT_APP;
      view = DEFAULT_VIEW;
    }
    const routeKey = `${app}/${view}`;

    // Handle special cases
    if (routeKey === 'alert/router' || routeKey === 'storyLayout/router') {
      setComponent(() => () => <></>);
      return;
    }

    const Component = () => loadComponent(app, view);

    setComponent(Component);
  }, [location]);

  return (
    <Suspense fallback={<LoadingCenter />}>
      {Component ? <Component /> : <LoadingCenter />}
    </Suspense>
  );
};

export default DynamicRouter;

